import React from "react";
import styled from "styled-components";

import {RangeSlider} from "components/ClientHome/CalculatorComponents";
import {colors} from "nxtconstants";


const InflationSlider = ({
  value,
  onChange,
  isInflation,
  onToggle,
  min,
  max,
  step,
  accentColor = colors.primary,
  showRangeLabels = false
}) => (
  <SliderControls $disabled={!isInflation}>
    <RangeSlider
      label={
        <LabelRow>
          <span>Inflation</span>
          <ToggleSwitch
            $active={isInflation}
            $accentColor={accentColor}
            aria-label="Toggle inflation"
            aria-pressed={isInflation}
            type="button"
            onClick={onToggle}
          />
        </LabelRow>
      }
      value={value}
      onChange={(nextValue) => {
        if (isInflation) {
          onChange(nextValue);
        }
      }}
      min={min}
      max={max}
      step={step}
      suffix="%"
      accentColor={accentColor}
      showRangeLabels={showRangeLabels}
    />
  </SliderControls>
);

const SliderControls = styled.div`
  opacity: ${(props) => (props.$disabled ? 0.45 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  transition: opacity 0.2s ease;
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ToggleSwitch = styled.button`
  position: relative;
  width: 3.6rem;
  height: 2rem;
  border: none;
  border-radius: 5rem;
  cursor: pointer;
  flex-shrink: 0;
  pointer-events: auto;
  background: ${(props) =>
    props.$active ? props.$accentColor || colors.primary : colors.lightGray};
  transition: background 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    top: 0.2rem;
    left: ${(props) => (props.$active ? "1.8rem" : "0.2rem")};
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    background: ${colors.white};
    transition: left 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  }
`;

export default InflationSlider;
